import type {ReactNode} from 'react';

const Visibility = ({
  visible,
  children,
}: {
  visible: boolean;
  children: ReactNode;
}) => {
  return visible ? children : null;
};
export default Visibility;
